import axios from 'axios'
import { refreshAccessToken } from './authService';

const path = window.location.protocol + '//' + window.location.host;

const baseService = axios.create({
  baseURL: process.env.REACT_APP_URL_CONSULTING_RESEARCH_API || path,
  headers: {
    "Content-Type": 'application/json',
    "Access-Control-Allow-Origin": "*",
  }
});


baseService.interceptors.request.use(async (config) => {
  console.log('Interceptor - Adicionando informações do usuário ao cabeçalho');
  try {
    const access_token = localStorage.getItem('access_token');
    if (access_token) {
      config.withCredentials = true;
      config.headers.Authorization = `Bearer ${access_token}`;
    }

    const userEmail = localStorage.getItem('userEmail');
    if (userEmail) {
      config.headers['x-user-email'] = userEmail;
    }

    return config;
  } catch (error) {
    console.error('Erro no interceptor:', error);
    return config;
  }
}, (error) => {
  console.error('Erro no interceptor de requisição:', error);
  return Promise.reject(error);
});

/* baseService.interceptors.request.use(async (config) => {
  console.log('Interceptor - Validando token');
  try {
    const isTokenValid = await validateAccessToken();
    console.log('Token válido?', isTokenValid);
    if (isTokenValid) {
      console.log('Configurando token na requisição');
      config.withCredentials = true;
      const access_token = getCookie('access_token'); // Use o token do cookie
      config.headers.Authorization = access_token ? `Bearer ${access_token}` : '';

      const userEmail = localStorage.getItem('userEmail');
      if (userEmail) config.headers['x-user-email'] = userEmail;
      // Nota: userRoles não parece ser definido no localStorage, então removi essa parte
    }
    return config;
  } catch (error) {
    //console.error('Erro no interceptor:', error);
    return config;
  }
}, (error) => {
  //console.error('Erro no interceptor de requisição:', error);
  return Promise.reject(error)
}); */

/* function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
} */

// Interceptor para refresh automático do token
baseService.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Redireciona para login em caso de 401 ou 403
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Se não já tentou fazer refresh
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        
        const refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
          try {
            await refreshAccessToken();
            // Atualiza o header da requisição original com o novo token
            originalRequest.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
            return baseService(originalRequest);
          } catch (refreshError) {
            // Se o refresh falhar, limpa tudo e redireciona
            localStorage.clear();
            window.location.href = '/login';
            return Promise.reject(refreshError);
          }
        } else {
          // Não há refresh token, redireciona para login
          localStorage.clear();
          window.location.href = '/login';
          return Promise.reject(error);
        }
      } else {
        // Já tentou refresh e falhou, redireciona para login
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(error);
      }
    }
    
    return Promise.reject(error);
  }
);

export default baseService;